import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white'
      } border-b border-gray-200`}
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-2 text-lg sm:text-xl font-bold text-gray-900 hover:text-red-600 transition-colors cursor-pointer flex-shrink-0"
          >
            <span className="hidden sm:inline">Business Capital Guide</span>
            <span className="sm:hidden">BCG</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
            <Link
              to="/"
              className={`text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/') && location.pathname === '/'
                  ? 'text-red-600'
                  : 'text-gray-700 hover:text-red-600'
              }`}
            >
              Home
            </Link>

            <Link
              to="/business-funding"
              className={`text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/business-funding')
                  ? 'text-red-600'
                  : 'text-gray-700 hover:text-red-600'
              }`}
            >
              Business Funding
            </Link>

            <Link
              to="/prequalification"
              className="inline-flex items-center gap-2 px-4 py-2 bg-red-600 text-white text-sm font-semibold rounded-lg hover:bg-red-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-file-list-3-line"></i>
              <span className="hidden xl:inline">Pre-Qualification</span>
              <span className="xl:hidden">Pre-Qual</span>
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700 hover:text-red-600 transition-colors cursor-pointer flex-shrink-0"
            aria-label="Toggle menu"
          >
            <i
              className={`text-2xl ${
                isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'
              }`}
            ></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="lg:hidden border-t border-gray-200 py-4">
            <nav className="flex flex-col gap-4">
              <Link
                to="/"
                className={`text-sm font-semibold transition-colors cursor-pointer ${
                  isActive('/') && location.pathname === '/'
                    ? 'text-red-600'
                    : 'text-gray-700 hover:text-red-600'
                }`}
              >
                Home
              </Link>

              <Link
                to="/business-funding"
                className={`text-sm font-semibold transition-colors cursor-pointer ${
                  isActive('/business-funding')
                    ? 'text-red-600'
                    : 'text-gray-700 hover:text-red-600'
                }`}
              >
                Business Funding
              </Link>

              <Link
                to="/prequalification"
                className="inline-flex items-center justify-center gap-2 px-4 py-2 bg-red-600 text-white text-sm font-semibold rounded-lg hover:bg-red-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-file-list-3-line"></i>
                Pre-Qualification
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
